(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoiceGpfsDialogController', InvoiceGpfsDialogController);

    InvoiceGpfsDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'ToastrService', 'GpfsBatchCustomService'];

    function InvoiceGpfsDialogController($timeout, $scope, $uibModalInstance, entity, ToastrService, GpfsBatchCustomService) {
        var vm = this;

        vm.entity = entity;
        vm.invoicesList = [];

        vm.clear = clear;
        vm.save = save;
        vm.init = init;

        init();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function init() {
            GpfsBatchCustomService.returnBatchInvoices(vm.entity.batchId).then(function(result) {
                vm.invoicesList = result.data;
                for (var i = 0; i < vm.invoicesList.length; i++) {
                    vm.invoicesList.exclude = false;
                }
            }, function (error) {
                vm.invoicesList = [];
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            GpfsBatchCustomService.revertBatchInvoices(vm.entity.batchId).then(function(result) {
                $uibModalInstance.close('save');
            }, function (error) {
                $uibModalInstance.close('save');
            });
        }
    }
})();
